<template>
  <div class="main">
    <means>
      <div slot="title">比价订单说明</div>
      <div slot="main-content">
        <div class="page-content">
          <div class="explain-one">
            <strong>什么是比价订单</strong>
            <span>
              您在拼多多app/小程序/H5访问此商品详情页，<br />
              然后在短时间内再通过钱收收自购该商品即为比价。</span
            >
          </div>
          <div class="explain-two">
            <strong>比价订单的返利</strong>
            <span> 涉及到比价的商品，您自购可能无返利</span>
          </div>
          <div class="explain-three">
            <strong>比价规避方法</strong>
            <div>
              <router-link to="/h5/instructions/meanOne" class="forward"
                ><p>1.直接使用钱收收APP</p>
                <img src="../../static/instructions/zhankai.png" alt="" />
              </router-link>
            </div>
            <div>
              <router-link to="/h5/instructions/meanTwo" class="forward"
                ><span>2.分享给好友代下单拿返利</span
                ><img src="../../static/instructions/zhankai.png" alt="" />
              </router-link>
            </div>
            <div>
              <router-link to="/h5/instructions/meanThree" class="forward"
                ><span>3.分享到微信延迟1小时购买</span
                ><img src="../../static/instructions/zhankai.png" alt="" />
              </router-link>
            </div>
            <div>
              <router-link to="/h5/instructions/meanFour" class="forward"
                ><span>4.分享给您其他微信号下单</span
                ><img src="../../static/instructions/zhankai.png" alt="" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </means>
  </div>
</template>

<script>
import Means from "./means.vue";
export default {
  components: {
    Means
  }
};
</script>

<style lang="less" scoped>
.main {
  background: url("~@/static/instructions/icome_bg_top@2x.png") center;
  height: 100vh;
}
.explain-one,
.explain-two,
.explain-three {
  border-radius: 40px;
  padding: 28px;
  background-color: #fff;
  margin: 0 auto;
  font-size: 28px;
  line-height: 50px;
  width: 610px;
  strong {
    display: block;
  }
}
.explain-one {
  margin-top: 52px;
}
.explain-two {
  margin-top: 32px;
}
.explain-three {
  margin-top: 38px;
  display: flex;
  flex-direction: column;
  div {
    display: flex;
    justify-content: space-between;
  }
}
.forward {
  width: 100vw;
  display: flex;
  justify-content: space-between;
  text-decoration: none;
  color: #ec4c07;
  img {
    margin-top: 10px;
    width: 32px;
    height: 32px;
  }
}
</style>
